function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_35_"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_6_",
  className: "st0",
  points: "18.6,85.5 21.3,28.1 76.9,11.1 111.4,47.6 111.4,102.2 54.8,118.9  "
}), /*#__PURE__*/React.createElement("polyline", {
  id: "XMLID_7_",
  className: "st0",
  points: "54.8,118.9 56.8,65 111.4,47.6  "
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_9_",
  className: "st0",
  x1: 56.8,
  y1: 65,
  x2: 21.3,
  y2: 28.1
}));
function SvgD6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 130",
    style: {
      enableBackground: "new 0 0 130 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD6);
export default __webpack_public_path__ + "static/media/d6.67daa769bc83c2f1d69ba6a68f6207dc.svg";
export { ForwardRef as ReactComponent };